export const PRELIMINARY_AWARD_APPROVAL = {
  QUALIFIES_0: 'Qualifies for $0 out of pocket max',
  QUALIFIES_100: 'Qualifies for $100 out of pocket max',
  NO_QUALIFY: 'Does not qualify for financial assistance',
  NEEDS_REVIEW: 'Needs Review'
}

export const ACCEPTANCE_CONDITIONS = {
  extensions: {
    pdf: 'application/pdf',
    png: 'image/png',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    tif: 'image/tif',
    tiff: 'image/tiff',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  limitSize: '18000000',
  limitCount: 15,
}

export const NONE_CIRCUMSTANCES_VALUE = '13'